export interface PricingCardStaticDetailsTypesV1 {
  topSectionImg: string;
  bgColor: string;
  offerHeading: string;
  additionInfo: {
    icon: string;
    fontColor: string;
    text: string;
  };
}
export const PricingCardStaticDetailsV1_1: PricingCardStaticDetailsTypesV1[] = [
  {
    topSectionImg: '',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #D4D2E3 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746783859_group1814222390.svg',
      fontColor: '#4B5159',
      text: 'Direct call with tax expert and Q&A session',
    },
  },
  {
    topSectionImg: '',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #9ADBC8 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      fontColor: '#6469E4',
      icon: 'https://assets.clear.in/cleartax/images/1746783790_group1814222391.svg',
      text: 'Live Video filing and Q&A session with tax experts',
    },
  },
  {
    topSectionImg: '',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #CB7871 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746015599_group18142223911.png',
      fontColor: '#E8743E',
      text: 'Live Video filing + Q&A session + video assistance for tax planning in the year',
    },
  },
  {
    topSectionImg: '',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #DDB92C 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1752124567_ultra-icon.svg',
      fontColor: '#7C3AED',
      text: 'Dedicated expert for the year + 24x7 access + complete tax strategy support',
    },
  },
];

export const PricingCardStaticDetailsV1_2: PricingCardStaticDetailsTypesV1[] = [
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460700_group1814222609.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #D4D2E3 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746783859_group1814222390.svg',
      fontColor: '#4B5159',
      text: 'Direct call with tax expert and Q&A session',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460792_group1814222610.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #9ADBC8 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      fontColor: '#6469E4',
      icon: 'https://assets.clear.in/cleartax/images/1746783790_group1814222391.svg',
      text: 'Live Video filing and Q&A session with tax experts',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460864_group1814222611.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #CB7871 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746015599_group18142223911.png',
      fontColor: '#E8743E',
      text: 'Live Video filing + Q&A session + video assistance for tax planning in the year',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751877794_group1814222612.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #DDB92C 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1752124567_ultra-icon.svg',
      fontColor: '#7C3AED',
      text: 'Dedicated expert for the year + 24x7 access + complete tax strategy support',
    },
  },
];

export const PricingCardStaticDetailsV1_3: PricingCardStaticDetailsTypesV1[] = [
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460700_group1814222609.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #D4D2E3 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746783859_group1814222390.svg',
      fontColor: '#4B5159',
      text: 'Direct call with tax expert and Q&A session',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460792_group1814222610.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #9ADBC8 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      fontColor: '#6469E4',
      icon: 'https://assets.clear.in/cleartax/images/1746783790_group1814222391.svg',
      text: 'Live Video filing and Q&A session with tax experts',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751460864_group1814222611.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #CB7871 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746015599_group18142223911.png',
      fontColor: '#E8743E',
      text: 'Live Video filing + Q&A session + video assistance for tax planning in the year',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1751877794_group1814222612.svg',
    bgColor:
      'radial-gradient(271.8% 308.37% at -181.95% -100.05%, #DDB92C 29.33%, #FFF 88.94%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1752124567_ultra-icon.svg',
      fontColor: '#7C3AED',
      text: 'Dedicated expert for the year + 24x7 access + complete tax strategy support',
    },
  },
];

// Additional plans to be added to the pricing data (new order)
export const additionalPlans = [
  {
    plan_id: 'prod_advance_tax_calculation',
    coupon: '',
  },
  {
    plan_id: 'prod_ask_expert_plan',
    coupon: '',
  },
  {
    plan_id: 'prod_tax_notice_management_plan',
    coupon: '',
  },
  {
    plan_id: 'prod_huf',
    coupon: '',
  },
];

// Old additional plans (kept for reference)
export const additionalPlansOld = [
  {
    plan_id: 'prod_huf',
    coupon: '',
  },
  {
    plan_id: 'prod_huf_suite',
    coupon: '',
  },
  {
    plan_id: 'prod_tax_notice_management_plan',
    coupon: '',
  },
  {
    plan_id: 'prod_ask_expert_plan',
    coupon: '',
  },
];
